<template>
  <div class="default-bg" style="min-height: 100vh; padding-bottom: 2rem;">
    <!-- Header do StyleGuide -->
    <div style="padding: 2rem;">
      <div class="white-bg" style="text-align: center; margin-bottom: 2rem; padding: 2rem;">
        <h1>StyleGuide - Sistema de Design BROBOT</h1>
        <h4>Documentação completa baseada nos componentes reais do sistema</h4>
        <div style="border-bottom: 2px solid #E1E3EB; margin: 2rem 0;"></div>
      </div>
    </div>

    <!-- Seção 1: SISTEMA DE CORES -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Sistema de Cores</h2>
      
      <!-- Cores Primárias -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Cores Primárias</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 0.8rem;">
          
          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="primary-bg" style="width: 100%; height: 50px; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#2D98DA</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.primary-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Azul principal</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:1-3</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="secondary-bg" style="width: 100%; height: 50px; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#E93F66</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.secondary-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Vermelho/Rosa</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:5-7</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="attention-bg" style="width: 100%; height: 50px; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#FFC866</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.attention-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Atenção/Alerta</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:9-11</div>
          </div>

        </div>
      </div>

      <!-- Backgrounds -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Backgrounds</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 0.8rem;">
          
          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="white-bg" style="width: 100%; height: 50px; border: 2px solid #E1E3EB; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#FFFFFF</div>
              <div style="position: absolute; bottom: 8px; left: 8px; color: #051B30; font-size: 10px;">Conteúdo</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.white-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#FFFFFF + radius</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:42-45</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="default-bg" style="width: 100%; height: 50px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#EDF0F5</div>
              <div style="position: absolute; bottom: 8px; left: 8px; color: #051B30; font-size: 10px; font-weight: bold;">Padrão</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.default-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#EDF0F5</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:32-35</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div class="tab-bg" style="width: 100%; height: 50px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#F5F7FA</div>
              <div style="position: absolute; bottom: 8px; left: 8px; color: #051B30; font-size: 10px; font-weight: bold;">Tabs</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">.tab-bg</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#F5F7FA</div>
            <div style="color: #999; font-size: 9px;">_colors.scss:37-40</div>
          </div>

        </div>
      </div>

      <!-- Texto e Especiais -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Texto e Especiais</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 0.8rem;">
          
          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: white; border: 1px solid #E1E3EB; margin-bottom: 0.7rem; display: flex; align-items: center; justify-content: center;">
              <span style="color: #051B30; font-size: 12px; font-weight: bold;">Texto</span>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$primary-text-color</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#051B30</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:12</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: white; border: 1px solid #E1E3EB; margin-bottom: 0.7rem; display: flex; align-items: center; justify-content: center;">
              <span style="color: #051b307a; font-size: 11px;">Secundário</span>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$secondary-text-color</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#051b307a</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:13</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: #D60B52; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#D60B52</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$sp-color</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Cor especial</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:23</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: #15CE9A; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#15CE9A</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$green-color</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Verde sucesso</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:9</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: #E9F2FB; border: 1px solid #E1E3EB; border-radius: 4px; margin-bottom: 0.7rem; position: relative;">
              <div style="position: absolute; top: 8px; right: 8px; background: rgba(0,0,0,0.7); padding: 2px 6px; border-radius: 3px; color: white; font-size: 10px; font-weight: bold;">#E9F2FB</div>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$light-blue</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">Azul claro</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:20</div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 0.8rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="width: 100%; height: 45px; background: white; border: 2px solid #E1E3EB; border-radius: 4px; margin-bottom: 0.7rem; display: flex; align-items: center; justify-content: center;">
              <span style="color: #E1E3EB; font-size: 10px;">Border</span>
            </div>
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 0.2rem; color: #051B30;">$border-color</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.2rem;">#E1E3EB</div>
            <div style="color: #999; font-size: 9px;">_variables.scss:15</div>
          </div>

        </div>
      </div>
      
    </div>

    <!-- Seção 2: TIPOGRAFIA -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Tipografia</h2>
      
      <!-- Fonte Principal -->
      <div style="margin-bottom: 2rem;">
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Fonte Principal</h3>
          <div style="font-family: 'Montserrat', sans-serif; font-size: 36px; font-weight: 300; text-align: center; margin-bottom: 0.7rem; color: #051B30;">Montserrat</div>
          <div style="text-align: center; margin-bottom: 0.5rem; color: #465059; font-size: 14px;">Abcdefghijklmnopqrstuvwxyz • 0123456789</div>
          <div style="color: #999; font-size: 11px; text-align: center;">font-family: 'Montserrat', sans-serif • _text.scss:1</div>
        </div>
      </div>

      <!-- Hierarquia e Elementos -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 3rem; margin-bottom: 2rem;">
        
        <!-- Hierarquia de Títulos -->
        <div>
          <h3 style="margin-bottom: 1.5rem; color: #051B30; font-size: 16px;">Hierarquia de Títulos</h3>
          
          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <h1 style="margin: 0 0 0.5rem 0;">Título H1</h1>
            <div style="color: #999; font-size: 11px;">h1 • color: $primary-text-color (sem font-size) • _text.scss:7-10</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <h2 style="margin: 0 0 0.5rem 0;">Título H2</h2>
            <div style="color: #999; font-size: 11px;">h2 • color: $primary-text-color (sem font-size) • _text.scss:7-10</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <h3 style="margin: 0 0 0.5rem 0;">Título H3</h3>
            <div style="color: #999; font-size: 11px;">h3 • 24px, color: $primary-text-color • _text.scss:12-15</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <h4 style="margin: 0 0 0.5rem 0;">Título H4</h4>
            <div style="color: #999; font-size: 11px;">h4 • 18px, color: $secondary-text-color • _text.scss:17-20</div>
          </div>

          <div>
            <h5 style="margin: 0 0 0.5rem 0;">Título H5</h5>
            <div style="color: #999; font-size: 11px;">h5 • 16px, color: $primary-text-color • _text.scss:22-25</div>
          </div>
        </div>

        <!-- Elementos de Texto -->
        <div>
          <h3 style="margin-bottom: 1.5rem; color: #051B30; font-size: 16px;">Elementos de Texto</h3>
          
          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <div class="p" style="margin: 0 0 0.5rem 0;">Parágrafo com classe .p - Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
            <div style="color: #999; font-size: 11px;">.p • 12px, color: $secondary-text-color • _text.scss:27-30</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <label style="margin: 0 0 0.5rem 0;">Label para formulários</label>
            <div style="color: #999; font-size: 11px;">label • 12px, color: $primary-text-color • _text.scss:32-35</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <div class="bold" style="margin: 0 0 0.5rem 0;">Texto bold aplicado</div>
            <div style="color: #999; font-size: 11px;">.bold • font-weight: bold • _text.scss:54-56</div>
          </div>

          <div style="border-bottom: 1px solid #E1E3EB; padding-bottom: 1rem; margin-bottom: 1rem;">
            <div class="paginate" style="margin: 0 0 0.5rem 0;">Texto paginação</div>
            <div style="color: #999; font-size: 11px;">.paginate • color: $primary-text-color • _text.scss:45-47</div>
          </div>

          <div>
            <div style="margin: 0 0 0.5rem 0; color: #051b307a; font-size: 14px;">Placeholder text</div>
            <div style="color: #999; font-size: 11px;">::placeholder • 14px, color: $secondary-text-color • _text.scss:49-52</div>
          </div>
        </div>
        
      </div>
      
    </div>

    <!-- Seção 3: SISTEMA DE BOTÕES -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Sistema de Botões</h2>
      
      <!-- Botão Base -->
      <div style="margin-bottom: 2rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Botão Base</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; align-items: center; gap: 2rem; margin-bottom: 1rem;">
            <button class="btn btn-primary">Botão Padrão</button>
            <div>
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn</div>
              <div style="color: #465059; font-size: 12px;">height: 40px • font-size: 12px • border-radius: 5px • font-weight: bold</div>
              <div style="color: #999; font-size: 11px;">_buttons.scss:1-10</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estados de Botão -->
      <div style="margin-bottom: 2rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Estados</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 1.5rem;">
          
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <button class="btn btn-primary">Normal</button>
              <button class="btn btn-primary" disabled>Desabilitado</button>
              <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem;">
                <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn-primary</div>
                <div style="color: #465059; font-size: 12px;">background: $btn-primary • color: white</div>
                <div style="color: #999; font-size: 11px;">_buttons.scss:12-30</div>
              </div>
            </div>
          </div>

          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <button class="btn btn-primary btn-sp">Normal SP</button>
              <button class="btn btn-primary btn-sp" disabled>Desabilitado SP</button>
              <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem;">
                <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn-sp</div>
                <div style="color: #465059; font-size: 12px;">background: $sp-color (#D60B52)</div>
                <div style="color: #999; font-size: 11px;">_buttons.scss:32-50</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Botões Outline -->
      <div style="margin-bottom: 2rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Botões Outline</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; flex-wrap: wrap; gap: 1rem; align-items: start;">
            
            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-outline">Outline</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-outline</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:142-162</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-outline-red">Outline Red</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-outline-red</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:164-174</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-red">Red Solid</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-red</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:176-186</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Tamanhos -->
      <div style="margin-bottom: 2rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tamanhos</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; flex-wrap: wrap; gap: 1.5rem; align-items: end;">
            
            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-primary btn-sm">Small</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-sm</div>
                <div style="color: #465059; font-size: 11px;">height: 35px</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:111-120</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-primary">Default</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">padrão</div>
                <div style="color: #465059; font-size: 11px;">height: 40px</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:1-10</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-primary btn-md">Medium</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-md</div>
                <div style="color: #465059; font-size: 11px;">padding: 0 40px</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:122-124</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-primary btn-lg">Large</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-lg</div>
                <div style="color: #465059; font-size: 11px;">padding: 0 50px</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:126-128</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <button class="btn btn-primary btn-xl">Extra Large</button>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.btn-xl</div>
                <div style="color: #465059; font-size: 11px;">padding: 0 60px</div>
                <div style="color: #999; font-size: 10px;">_buttons.scss:130-132</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
    </div>

    <!-- Seção 4: SISTEMA DE FORMULÁRIOS -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 1.5rem;">Sistema de Formulários</h2>
      
      <!-- Layout em 2 colunas -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 3rem; align-items: start;">
        
        <!-- COLUNA 1 -->
        <div style="display: flex; flex-direction: column; gap: 2rem;">
          
          <!-- Input Base -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Input Base</h3>
            <input class="input" placeholder="Input padrão" style="width: 100%; max-width: 300px; margin-bottom: 0.5rem;">
            <div style="font-weight: bold; color: #051B30; font-size: 12px; margin-bottom: 0.2rem;">.input</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.1rem;">border: 1.5px solid $border-color • min-height: 40px</div>
            <div style="color: #999; font-size: 10px;">_inputs.scss:44-51</div>
          </div>

          <!-- Tamanhos de Input -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Tamanhos</h3>
            <div style="display: flex; flex-direction: column; gap: 0.8rem;">
              
              <div style="display: flex; flex-direction: column; gap: 0.3rem;">
                <input class="input input-sm" placeholder="Small input">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-sm</span>
                  <span style="color: #465059;"> • width: 186px</span>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 0.3rem;">
                <input class="input input-md" placeholder="Medium input">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-md</span>
                  <span style="color: #465059;"> • width: 259px</span>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 0.3rem;">
                <input class="input input-lg" placeholder="Large input">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-lg</span>
                  <span style="color: #465059;"> • width: 383px</span>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 0.3rem;">
                <input class="input input-xl" placeholder="Extra large input">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-xl</span>
                  <span style="color: #465059;"> • width: 671px</span>
                </div>
              </div>

            </div>
          </div>

          <!-- Estado de Erro -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Estado de Erro</h3>
            <input class="input error-input" placeholder="Input com erro" style="width: 100%; max-width: 300px; margin-bottom: 0.5rem;">
            <div style="font-weight: bold; color: #051B30; font-size: 12px; margin-bottom: 0.2rem;">.error-input</div>
            <div style="color: #465059; font-size: 11px; margin-bottom: 0.1rem;">border-color: $secondary-color (#E93F66)</div>
            <div style="color: #999; font-size: 10px;">_inputs.scss:69-71</div>
          </div>

          <!-- Inputs de Busca -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Inputs de Busca</h3>
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              
              <div>
                <input class="search" placeholder="Buscar..." style="padding: 0.5rem; width: 100%; max-width: 250px; margin-bottom: 0.3rem;">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.search</span>
                  <span style="color: #465059;"> • background: $light-gray</span>
                </div>
              </div>

              <div>
                <input class="search-2" placeholder="Buscar 2..." style="padding: 0.5rem; width: 100%; max-width: 250px; margin-bottom: 0.3rem;">
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.search-2</span>
                  <span style="color: #465059;"> • background: white</span>
                </div>
              </div>

            </div>
          </div>
          
        </div>

        <!-- COLUNA 2 -->
        <div style="display: flex; flex-direction: column; gap: 2rem;">
          
          <!-- Selects/Dropdowns -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Selects/Dropdowns</h3>
            <div style="display: flex; flex-direction: column; gap: 1.2rem;">
              
              <div>
                <select class="browser-default custom-select" style="width: 100% !important; max-width: 350px; padding: 8px 12px !important; margin-bottom: 0.5rem;">
                  <option>Data de atualização</option>
                  <option>Data de criação</option>
                  <option>Data da infração</option>
                  <option>Data de vencimento</option>
                </select>
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.browser-default.custom-select</span>
                  <div style="color: #465059; margin-top: 0.1rem;">Select padrão do sistema • font-size: 12px</div>
                </div>
              </div>

              <div>
                <select class="form-control" style="width: 100% !important; max-width: 350px; padding: 8px 12px !important; margin-bottom: 0.5rem;">
                  <option>Selecionar valor</option>
                  <option>Valor A</option>
                  <option>Valor B</option>
                  <option>Valor C</option>
                </select>
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.form-control</span>
                  <div style="color: #465059; margin-top: 0.1rem;">Select com classe form-control • font-size: 12px</div>
                </div>
              </div>

              <div>
                <div style="margin-bottom: 0.5rem;">
                  <Select2 v-model="select2Values" :options="select2Options" />
                </div>
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">&lt;Select2&gt;</span>
                  <div style="color: #465059; margin-top: 0.1rem;">Componente Vue para seleção múltipla</div>
                  <div style="color: #465059; margin-top: 0.1rem;">• Tags azuis • Busca • Remoção individual</div>
                </div>
              </div>
              
            </div>
          </div>

          <!-- Links -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Links</h3>
            <a class="a" href="#" style="display: inline-block; margin-bottom: 0.5rem;">Link padrão com hover</a>
            <div style="font-size: 11px;">
              <span style="font-weight: bold; color: #051B30;">.a</span>
              <div style="color: #465059; margin-top: 0.1rem;">color: $link (#4976EF) • hover: underline</div>
            </div>
          </div>

          <!-- Text Areas -->
          <div>
            <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 14px; font-weight: 600;">Text Areas</h3>
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              
              <div>
                <textarea class="input-texto" placeholder="Textarea grande..." style="width: 100%; max-width: 350px; height: 120px; margin-bottom: 0.3rem;"></textarea>
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-texto</span>
                  <span style="color: #465059;"> • max-width: 750px • height: 300px</span>
                </div>
              </div>

              <div>
                <textarea class="input-texto-2" placeholder="Textarea menor..." style="width: 100%; max-width: 350px; height: 80px; margin-bottom: 0.3rem;"></textarea>
                <div style="font-size: 11px;">
                  <span style="font-weight: bold; color: #051B30;">.input-texto-2</span>
                  <span style="color: #465059;"> • max-width: 765px • height: 150px</span>
                </div>
              </div>

            </div>
          </div>
          
        </div>
        
      </div>
      
    </div>

    <!-- Seção 5: SISTEMA DE TABELAS -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Sistema de Tabelas</h2>
      
      <!-- Tags de Status -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tags de Status (Círculos 10x10px)</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; flex-wrap: wrap; gap: 1.5rem; margin-bottom: 1rem;">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-blue"></div>
              <span style="font-size: 12px; color: #051B30;">Blue</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-red"></div>
              <span style="font-size: 12px; color: #051B30;">Red</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-green"></div>
              <span style="font-size: 12px; color: #051B30;">Green</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-yellow"></div>
              <span style="font-size: 12px; color: #051B30;">Yellow</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-orange"></div>
              <span style="font-size: 12px; color: #051B30;">Orange</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-purple"></div>
              <span style="font-size: 12px; color: #051B30;">Purple</span>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div class="tag tag-black"></div>
              <span style="font-size: 12px; color: #051B30;">Black</span>
            </div>
          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.tag + .tag-{color}</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">width: 10px • height: 10px • border-radius: 100%</div>
            <div style="color: #999; font-size: 11px;">_table.scss:1-38</div>
          </div>
        </div>
      </div>

      <!-- Tabela com Marcadores -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tabela com Marcadores e Tags</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div class="wrap-table">
            <table class="table-align">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Descrição</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="marker-blue" style="color: #051B30;">001</td>
                  <td><div class="tag tag-blue"></div></td>
                  <td class="truncate-2" style="color: #051B30;">Lorem ipsum dolor sit amet consectetur</td>
                  <td style="color: #051B30;">Tipo A</td>
                </tr>
                <tr>
                  <td class="marker-green" style="color: #051B30;">002</td>
                  <td><div class="tag tag-green"></div></td>
                  <td class="truncate-2" style="color: #051B30;">Consectetur adipiscing elit sed do eiusmod</td>
                  <td style="color: #051B30;">Tipo B</td>
                </tr>
                <tr>
                  <td class="marker-red" style="color: #051B30;">003</td>
                  <td><div class="tag tag-red"></div></td>
                  <td class="truncate-2" style="color: #051B30;">Tempor incididunt ut labore et dolore magna</td>
                  <td style="color: #051B30;">Tipo C</td>
                </tr>
                <tr>
                  <td class="marker-yellow" style="color: #051B30;">004</td>
                  <td><div class="tag tag-yellow"></div></td>
                  <td class="truncate-2" style="color: #051B30;">Aliqua enim ad minim veniam quis nostrud</td>
                  <td style="color: #051B30;">Tipo D</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.wrap-table + .table-align + td.marker-{color}</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Container responsivo • alinhamento vertical • marcadores laterais coloridos</div>
            <div style="color: #999; font-size: 11px;">_table.scss:76-80 + 140-167 + 204-208</div>
          </div>
        </div>
      </div>

      <!-- Tabela Bootstrap + Border + Align (Padrão Real do Sistema) -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tabela Bootstrap (Padrão do Sistema)</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div class="wrap-table">
            <table class="table table-borderless table-border table-align">
              <thead>
                <tr>
                  <th style="padding-left: 16px;">Código</th>
                  <th>Nome</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="marker-blue bold" style="color: #051B30;">ABC001</td>
                  <td class="truncate-2" style="color: #051B30;">Item de exemplo Alpha</td>
                  <td style="color: #051B30;">Ativo</td>
                  <td>
                    <button class="btn btn-outline btn-sm">
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td class="marker-green bold" style="color: #051B30;">ABC002</td>
                  <td class="truncate-2" style="color: #051B30;">Item de exemplo Beta</td>
                  <td style="color: #051B30;">Processando</td>
                  <td>
                    <button class="btn btn-outline btn-sm">
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td class="marker-red bold" style="color: #051B30;">ABC003</td>
                  <td class="truncate-2" style="color: #051B30;">Item de exemplo Gamma</td>
                  <td style="color: #051B30;">Erro</td>
                  <td>
                    <button class="btn btn-outline btn-sm">
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.table.table-borderless.table-border.table-align</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Padrão mais usado no sistema • Bootstrap + bordas customizadas • alinhamento vertical central • markers coloridos</div>
            <div style="color: #999; font-size: 11px;">cm-frotas/Table.vue • cm-embarcador/Table.vue • _table.scss:76-99</div>
          </div>
        </div>
      </div>

      <!-- Tabela DFe (Admin/Sistema) -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tabela DFe (Admin)</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <table class="table table-borderless table-dfe">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" style="margin-right: 0.5rem;" />
                </th>
                <th>ID</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding-top: 8px;">
                  <input type="checkbox" />
                </td>
                <td style="color: #051B30; vertical-align: middle;">1001</td>
                <td style="color: #051B30; vertical-align: middle;">Documento Fiscal</td>
                <td style="color: #051B30; vertical-align: middle;">NFe</td>
                <td style="color: #051B30; vertical-align: middle;">Autorizada</td>
                <td style="vertical-align: middle;">
                  <button class="btn btn-outline btn-sm">
                    <i class="fas fa-copy"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 8px;">
                  <input type="checkbox" />
                </td>
                <td style="color: #051B30; vertical-align: middle;">1002</td>
                <td style="color: #051B30; vertical-align: middle;">Documento Fiscal</td>
                <td style="color: #051B30; vertical-align: middle;">CTe</td>
                <td style="color: #051B30; vertical-align: middle;">Processando</td>
                <td style="vertical-align: middle;">
                  <button class="btn btn-outline btn-sm">
                    <i class="fas fa-copy"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.table.table-borderless.table-dfe</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Tabela para admin/DFe • padding-top especial na 2ª célula • vertical-align: middle • padding-left no primeiro th</div>
            <div style="color: #999; font-size: 11px;">dfe/Table.vue • admin/accounts/Index.vue • _table.scss:101-113</div>
          </div>
        </div>
      </div>

      <!-- Classes de Truncate -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Classes de Truncate</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            
            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="truncate-0" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto de exemplo muito longo para demonstrar truncamento</div>
              <div style="font-size: 11px; color: #465059;">max-width: 100px</div>
            </div>

            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="truncate-1" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto de exemplo muito longo para demonstrar truncamento</div>
              <div style="font-size: 11px; color: #465059;">max-width: 150px</div>
            </div>

            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="truncate-2" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto de exemplo muito longo para demonstrar truncamento</div>
              <div style="font-size: 11px; color: #465059;">max-width: 200px</div>
            </div>

            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="truncate-3" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto de exemplo muito longo para demonstrar o comportamento do truncamento</div>
              <div style="font-size: 11px; color: #465059;">max-width: 300px</div>
            </div>

            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="truncate-4" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto de exemplo muito longo para demonstrar o comportamento do truncamento em diferentes larguras</div>
              <div style="font-size: 11px; color: #465059;">max-width: 500px</div>
            </div>

          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.truncate-{0-4}</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">text-overflow: ellipsis • white-space: nowrap • overflow: hidden</div>
            <div style="color: #999; font-size: 11px;">_table.scss:169-202</div>
          </div>
        </div>
      </div>

    </div>

    <!-- Seção 6: SISTEMA DE CARDS -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Sistema de Cards</h2>
      
      <!-- Card Base -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Card Base</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div class="card">
            <h4>Card Base</h4>
            <p>Estrutura básica do card com bordas e sombra padrão do sistema</p>
          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.card</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">margin-top: 1rem • border: 2px solid $border-color • box-shadow • color: rgba(5,27,48,0.5)</div>
            <div style="color: #999; font-size: 11px;">_cards.scss:1-6</div>
          </div>
        </div>
      </div>

      <!-- Cards Dashboard Reais -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Cards Dashboard (Estrutura Real)</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1.5rem;">
          
          <div class="card card-status-top green-indicator text-uppercase">
            <p><strong>CARD VERDE</strong></p>
            <h3><strong>123</strong></h3>
          </div>

          <div class="card card-status-top red-indicator text-uppercase">
            <p><strong>CARD VERMELHO</strong></p>
            <h3><strong>456</strong></h3>
          </div>

          <div class="card card-status-top blue-indicator text-uppercase">
            <p><strong>CARD AZUL</strong></p>
            <h3><strong>789</strong></h3>
          </div>

          <div class="card card-status-top yellow-indicator text-uppercase">
            <p><strong>CARD AMARELO</strong></p>
            <h3><strong>321</strong></h3>
          </div>

        </div>
        <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
          <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.card.card-status-top.{color}-indicator</div>
          <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Estrutura real dos cards de dashboard • padding: 1em • border-radius: 5px</div>
          <div style="color: #999; font-size: 11px;">_cards.scss:21-24 + 33-61 • uso real em DashboardDfe.vue</div>
        </div>
      </div>

      <!-- Cards Bottom -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Cards Bottom (Valores Detalhados)</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
          
          <div class="card card-status-bottom">
            <p><strong>EXEMPLO CARD 1</strong></p>
            <h5><strong>100</strong></h5>
          </div>

          <div class="card card-status-bottom">
            <p><strong>EXEMPLO CARD 2</strong></p>
            <h5><strong>200</strong></h5>
          </div>

          <div class="card card-status-bottom">
            <p><strong>EXEMPLO CARD 3</strong></p>
            <h5><strong>300</strong></h5>
          </div>

          <div class="card card-status-bottom">
            <p><strong>EXEMPLO CARD 4</strong></p>
            <h5><strong>400</strong></h5>
          </div>

        </div>
        <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
          <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.card.card-status-bottom</div>
          <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">height: 73px • border-left: 5px solid $primary-color • padding: 1em • line-height: 9px</div>
          <div style="color: #999; font-size: 11px;">_cards.scss:26-31 • usado para valores detalhados</div>
        </div>
      </div>

    </div>

    <!-- Seção 7: ÍCONES E COMPONENTES ESPECIAIS -->
    <div style="padding: 2rem;">
      <h2 style="margin-bottom: 2rem;">Ícones e Componentes Especiais</h2>

      <!-- Loading Component Real -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Loading Component</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="position: relative; height: 100px; background: rgba(25, 25, 112, 0.3); border-radius: 8px;">
            <Loading :load="true" message="Carregando dados..." />
          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">&lt;Loading&gt;</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Componente com animação .lds-ripple • props: load, message</div>
            <div style="color: #999; font-size: 11px;">src/components/shares/Loading.vue • animação CSS real</div>
          </div>
        </div>
      </div>

      <!-- Ícones Base -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Classes de Ícones</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1.5rem;">
            
            <div style="display: flex; flex-direction: column; gap: 0.8rem;">
              <div class="icon-card">
                <BarcodeIcon />
              </div>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">&lt;BarcodeIcon&gt;</div>
                <div style="color: #465059; font-size: 11px;">Ícone SVG customizado</div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 0.8rem;">
              <div class="icon-card">
                <i class="fas fa-file" style="font-size: 24px;"></i>
              </div>
              <div style="text-align: center;">
                <div style="font-weight: bold; color: #051B30; font-size: 12px;">.icon</div>
                <div style="color: #465059; font-size: 11px;">color: $secondary-text-color</div>
              </div>
            </div>

          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.icon-card + componentes SVG</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">64x64px • background gradient • border: 1px solid #E1E3EB</div>
            <div style="color: #999; font-size: 11px;">_icons.scss:24-38 + components/icons/</div>
          </div>
        </div>
      </div>

      <!-- Select2 Component -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Select2 Multi-Select</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <Select2 v-model="select2Values" :options="select2Options" />
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">&lt;Select2&gt;</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Componente Vue completo • tags azuis #318BE3 • busca e remoção</div>
            <div style="color: #999; font-size: 11px;">src/components/shares/Select2.vue</div>
          </div>
        </div>
      </div>

      <!-- Utilitárias de Texto -->
      <div style="margin-bottom: 2.5rem;">
        <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Utilitárias de Texto</h3>
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            
            <div style="display: flex; align-items: center; gap: 2rem;">
              <div style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30; border: 2px solid #E1E3EB;">
                <div style="width: 100px; overflow: hidden;">
                  <span class="nowrap">Este texto muito longo não vai quebrar linha</span>
                </div>
              </div>
              <div style="font-size: 12px; color: #465059;">.nowrap - demonstra texto sem quebra</div>
            </div>

            <div style="display: flex; align-items: center; gap: 2rem;">
              <div class="text-align-center" style="background: #F5F7FA; padding: 1rem; border-radius: 3px; width: 200px; color: #051B30;">Texto centralizado</div>
              <div style="font-size: 12px; color: #465059;">.text-align-center</div>
            </div>

            <div style="display: flex; align-items: center; gap: 2rem;">
              <div class="bold" style="background: #F5F7FA; padding: 0.5rem; border-radius: 3px; color: #051B30;">Texto em negrito</div>
              <div style="font-size: 12px; color: #465059;">.bold</div>
            </div>

          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">Classes Utilitárias</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Utilitários para texto e layout</div>
            <div style="color: #999; font-size: 11px;">_main.scss:19-21 • _cards.scss:8-10 • _text.scss:54-56</div>
          </div>
        </div>
      </div>

      <!-- Seção 8: SISTEMA DE NAVEGAÇÃO -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Navegação</h2>
        
        <!-- Sidebar Navigation -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Sidebar de Navegação</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <!-- Simulação da sidebar real -->
            <div style="background: white; width: 135px; min-height: 280px; border-right: 1px solid #E1E3EB;">
              <ul class="navbar-nav sidebar" style="padding: 0; margin: 0;">
                
                <a class="nav-link nav-item" style="text-decoration: none; color: inherit;">
                  <li>
                    <i style="display: block; margin-bottom: 0.5em; text-align: center;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        <line x1="9" y1="9" x2="15" y2="9"/>
                        <line x1="9" y1="15" x2="15" y2="15"/>
                      </svg>
                    </i>Item 1
                  </li>
                </a>

                <a class="nav-link nav-item nav-item-active" style="text-decoration: none; color: inherit;">
                  <li>
                    <i style="display: block; margin-bottom: 0.5em; text-align: center;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="7" height="7"/>
                        <rect x="14" y="3" width="7" height="7"/>
                        <rect x="14" y="14" width="7" height="7"/>
                        <rect x="3" y="14" width="7" height="7"/>
                      </svg>
                    </i>Item 2
                  </li>
                </a>

                <a class="nav-link nav-item" style="text-decoration: none; color: inherit;">
                  <li>
                    <i style="display: block; margin-bottom: 0.5em; text-align: center;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </i>Item 3
                  </li>
                </a>

              </ul>
            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.nav-item • .nav-item-active • .sidebar</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Sidebar vertical fixa • router-links • hover azul com borda esquerda • ícones Feather</div>
              <div style="color: #999; font-size: 11px;">_nav.scss:8-46 • src/components/dashboard/Sidebar.vue</div>
            </div>
          </div>
        </div>

        <!-- Dashboard Nav -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Navegação Dashboard</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <!-- Simulação do btn-group d-flex dashboard-nav real -->
            <div class="btn-group d-flex dashboard-nav" style="width: 100%; box-shadow: 0px 4px 5px rgba(134, 134, 134, 0.25);">
              
              <a class="btn btn-dashboard-nav w-100" style="text-decoration: none; color: inherit; border-radius: 0;">
                <h4 style="margin: 0; font-size: 16px; color: #465059;">Nav 1</h4>
              </a>

              <a class="btn btn-dashboard-nav btn-dashboard-nav-active w-100" style="text-decoration: none; color: inherit; border-radius: 0;">
                <h4 style="margin: 0; font-size: 16px;">Nav 2</h4>
              </a>

              <a class="btn btn-dashboard-nav w-100" style="text-decoration: none; color: inherit; border-radius: 0;">
                <h4 style="margin: 0; font-size: 16px; color: #465059;">Nav 3</h4>
              </a>

              <a class="btn btn-dashboard-nav w-100" style="text-decoration: none; color: inherit; border-radius: 0;">
                <h4 style="margin: 0; font-size: 16px; color: #465059;">Nav 4</h4>
              </a>

              <a class="btn btn-dashboard-nav w-100" style="text-decoration: none; color: inherit; border-radius: 0;">
                <h4 style="margin: 0; font-size: 16px; color: #465059;">Nav 5</h4>
              </a>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 2rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn-dashboard-nav • .btn-dashboard-nav-active • .btn-group.d-flex</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Botões grandes (min-height: 72px) • padding-top: 1.7em • borda inferior 5px ao hover/ativo • ocupam largura total</div>
              <div style="color: #999; font-size: 11px;">_buttons.scss:214-256 • src/components/dashboard/Index.vue</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 9: SISTEMA DE TIMELINE -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Timeline</h2>
        
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <ul class="timeline" style="padding: 0; margin: 0;">
            <li class="timeline-row" style="margin-bottom: 1rem;">
              <div style="color: #051B30; font-weight: bold; margin-bottom: 0.3rem;">Evento 1</div>
              <div style="color: #465059; font-size: 12px;">Descrição do primeiro evento da timeline</div>
              <div style="color: #999; font-size: 11px; margin-top: 0.3rem;">10:30 - 28/08/2025</div>
            </li>
            <li class="timeline-row" style="margin-bottom: 1rem;">
              <div style="color: #051B30; font-weight: bold; margin-bottom: 0.3rem;">Evento 2</div>
              <div style="color: #465059; font-size: 12px;">Descrição do segundo evento da timeline</div>
              <div style="color: #999; font-size: 11px; margin-top: 0.3rem;">09:15 - 28/08/2025</div>
            </li>
            <li class="timeline-row">
              <div style="color: #051B30; font-weight: bold; margin-bottom: 0.3rem;">Evento 3</div>
              <div style="color: #465059; font-size: 12px;">Descrição do terceiro evento da timeline</div>
              <div style="color: #999; font-size: 11px; margin-top: 0.3rem;">08:45 - 28/08/2025</div>
            </li>
          </ul>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.timeline • .timeline-row</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Lista de eventos cronológicos • bordas arredondadas</div>
            <div style="color: #999; font-size: 11px;">_timeline.scss:1-9</div>
          </div>
        </div>
      </div>

      <!-- Seção 10: SISTEMA DE PAGINAÇÃO -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Paginação</h2>
        
        <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            
            <div class="page-item2">1</div>
            <div class="page-item2 active-class2">2</div>
            <div class="page-item2">3</div>
            <div class="page-item2">4</div>
            <div class="page-item2">5</div>
            <div style="margin: 0 0.5rem; color: #465059;">...</div>
            <div class="page-item2">10</div>

          </div>
          <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
            <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.page-item2 • .active-class2</div>
            <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Paginação customizada • item ativo com fundo cinza</div>
            <div style="color: #999; font-size: 11px;">_pagination.scss:8-26</div>
          </div>
        </div>
      </div>

      <!-- Seção 11: INPUTS ESPECIAIS -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Inputs Especiais</h2>
        
        <!-- Input Texto -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Área de Texto</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <textarea class="input input-texto" style="color: #051B30;" placeholder="Texto longo aqui...">Exemplo de texto em uma área grande para conteúdo extenso. Esta textarea tem dimensões específicas definidas no sistema.</textarea>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.input-texto</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Área de texto 750px x 300px • centralizada</div>
              <div style="color: #999; font-size: 11px;">_inputs.scss:153-157</div>
            </div>
          </div>
        </div>

        <!-- Input Texto 2 -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Área de Texto Compacta</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <textarea class="input input-texto-2" style="color: #051B30;" placeholder="Texto médio aqui...">Exemplo de texto em uma área média para conteúdo moderado.</textarea>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.input-texto-2</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Área de texto 765px x 150px • mais compacta</div>
              <div style="color: #999; font-size: 11px;">_inputs.scss:159-162</div>
            </div>
          </div>
        </div>

        <!-- Search Inputs -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Campos de Busca</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; flex-direction: column; gap: 1.5rem;">
              
              <div>
                <input type="text" class="input search" style="color: #051B30;" placeholder="Busca com fundo cinza" />
                <div style="font-size: 12px; color: #465059; margin-top: 0.5rem;">.search - sem borda, fundo #EDF0F5</div>
              </div>

              <div>
                <input type="text" class="input search-2" style="color: #051B30;" placeholder="Busca com fundo branco" />
                <div style="font-size: 12px; color: #465059; margin-top: 0.5rem;">.search-2 - sem borda, fundo branco</div>
              </div>

            </div>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.search • .search-2</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Campos de busca especializados • sem bordas</div>
              <div style="color: #999; font-size: 11px;">_inputs.scss:143-151</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 12: BOTÕES ADICIONAIS -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Botões Adicionais</h2>
        
        <!-- Botões Coloridos -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Botões Especiais</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
              
              <button class="btn btn-sp">SP Color</button>
              <button class="btn btn-red">Vermelho</button>
              <button class="btn btn-blue">Azul</button>
              <button class="btn btn-icon" style="background: #2D98DA; color: white;">
                <i class="fas fa-search"></i>
              </button>

            </div>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn-sp • .btn-red • .btn-blue • .btn-icon</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Botões com cores especiais • ícone quadrado 32x32px</div>
              <div style="color: #999; font-size: 11px;">_buttons.scss:32-50, 92-97, 99-109, 176-186</div>
            </div>
          </div>
        </div>

        <!-- Botões Outline -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Botões Outline</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
              
              <button class="btn btn-outline">Outline</button>
              <button class="btn btn-outline-red">Outline Vermelho</button>
              <button class="btn btn-outline-active">Outline Ativo</button>

            </div>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.btn-outline • .btn-outline-red • .btn-outline-active</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Botões com borda • hover preenche fundo</div>
              <div style="color: #999; font-size: 11px;">_buttons.scss:142-193</div>
            </div>
          </div>
        </div>

        <!-- Botões de Busca -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Botões de Busca</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            <div style="display: flex; align-items: center; gap: 1rem;">
              
              <div style="display: flex; align-items: stretch;">
                <input type="text" class="input search" placeholder="Digite sua busca..." style="border-top-right-radius: 0; border-bottom-right-radius: 0; width: 200px; color: #051B30;" />
                <button class="search-button">
                  <i class="fas fa-search"></i>
                </button>
              </div>

              <div style="display: flex; align-items: stretch;">
                <input type="text" class="input search-2" placeholder="Busca branca..." style="border-top-right-radius: 0; border-bottom-right-radius: 0; width: 200px; color: #051B30;" />
                <button class="search-button-2">
                  <i class="fas fa-search"></i>
                </button>
              </div>

            </div>
            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.search-button • .search-button-2</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Botões acoplados aos inputs de busca • bordas arredondadas direita</div>
              <div style="color: #999; font-size: 11px;">_buttons.scss:134-140, 201-208</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 13: SISTEMA DE MODAIS E POPUPS -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Modais e Popups</h2>
        
        <!-- Modal Bootstrap Customizado -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Modal Customizado</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
              
              <button class="btn btn-primary" @click="showModal = true">
                Abrir Modal
              </button>

              <button class="btn btn-outline" @click="showLargeModal = true">
                Modal Grande
              </button>

              <button class="btn btn-sp" @click="showSmallModal = true">
                Modal Pequeno
              </button>

            </div>

            <!-- Modal Padrão -->
            <div v-if="showModal" class="modal" @keydown.esc="showModal = false" tabindex="0" @click="checkModalClick" style="display: block; background: rgba(0, 0, 0, 0.7); position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 1050;">
              <div class="modal-dialog modal-lg" style="min-width: 450px; min-height: 300px; margin: 1.75rem auto;">
                <div class="modal-content" style="border: none;">
                  
                  <div class="modal-header">
                    <div class="modal-title" style="font-size: 18px; font-weight: 600; color: #051B30;">
                      Título do Modal
                    </div>
                    <span @click="showModal = false" style="cursor: pointer; transition: all 0.2s ease-in-out;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </span>
                  </div>

                  <div class="modal-body default-bg" style="border-radius: 5px; padding: 1.5rem; color: #051B30;">
                    <p>Conteúdo do modal aqui. Este é um exemplo funcional do modal customizado usado no sistema.</p>
                    <div class="form-group">
                      <label>Campo exemplo:</label>
                      <input type="text" class="input form-control" placeholder="Digite algo..." style="color: #051B30;" />
                    </div>
                  </div>

                  <div class="modal-footer default-bg" style="border: none; border-radius: 5px; padding: 1.5rem; display: flex; justify-content: flex-end; gap: 0.5rem;">
                    <button class="btn btn-outline" @click="showModal = false">Cancelar</button>
                    <button class="btn btn-primary" @click="showModal = false">Confirmar</button>
                  </div>

                </div>
              </div>
            </div>

            <!-- Modal Grande -->
            <div v-if="showLargeModal" class="modal" @keydown.esc="showLargeModal = false" tabindex="0" @click="checkLargeModalClick" style="display: block; background: rgba(0, 0, 0, 0.7); position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 1050;">
              <div class="modal-dialog modal-xl" style="max-width: 1200px; margin: 1.75rem auto;">
                <div class="modal-content" style="border: none;">
                  
                  <div class="modal-header">
                    <div class="modal-title" style="font-size: 18px; font-weight: 600; color: #051B30;">
                      Modal Extra Grande
                    </div>
                    <span @click="showLargeModal = false" style="cursor: pointer;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </span>
                  </div>

                  <div class="modal-body default-bg" style="border-radius: 5px; padding: 1.5rem; color: #051B30;">
                    <p>Modal com tamanho XL (1200px) para conteúdo extenso como tabelas e formulários complexos.</p>
                  </div>

                </div>
              </div>
            </div>

            <!-- Modal Pequeno -->
            <div v-if="showSmallModal" class="modal" @keydown.esc="showSmallModal = false" tabindex="0" @click="checkSmallModalClick" style="display: block; background: rgba(0, 0, 0, 0.7); position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 1050;">
              <div class="modal-dialog modal-sm" style="max-width: 300px; margin: 1.75rem auto;">
                <div class="modal-content" style="border: none;">
                  
                  <div class="modal-header">
                    <div class="modal-title" style="font-size: 16px; font-weight: 600; color: #051B30;">
                      Confirmação
                    </div>
                    <span @click="showSmallModal = false" style="cursor: pointer;">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </span>
                  </div>

                  <div class="modal-body default-bg" style="border-radius: 5px; padding: 1.5rem; color: #051B30;">
                    <p style="margin-bottom: 1rem;">Deseja continuar?</p>
                    <div style="display: flex; gap: 0.5rem; justify-content: flex-end;">
                      <button class="btn btn-outline btn-sm" @click="showSmallModal = false">Não</button>
                      <button class="btn btn-primary btn-sm" @click="showSmallModal = false">Sim</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">Modal • v-model • ESC para fechar</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Tamanhos: .modal-sm, .modal-lg, .modal-xl • Header/Body/Footer • background escuro 70%</div>
              <div style="color: #999; font-size: 11px;">src/components/shares/specialTag/Modal.vue</div>
            </div>
          </div>
        </div>

        <!-- Popup Animado -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Popup Animado</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="position: relative; display: inline-block; margin-left: 150px;">
              
              <button class="btn btn-outline" @click="showPopup = !showPopup">
                {{ showPopup ? 'Fechar' : 'Abrir' }} Popup
              </button>

              <!-- Popup Container -->
              <div v-if="showPopup" style="position: absolute; top: 50px; left: -80px; z-index: 1000;">
                
                <!-- Arrow -->
                <div style="position: absolute; left: calc(50% - 10px); top: -10px; width: 0; height: 0; border-width: 0 10px 10px 10px; border-color: transparent transparent white transparent; border-style: solid; filter: drop-shadow(0 -1px 2px rgba(0,0,0,0.1));"></div>
                
                <!-- Popup Content -->
                <div style="box-shadow: 0 4px 30px rgba(0, 0, 0, 0.23); border-radius: 8px; background: white; width: 200px; padding: 1rem; animation: popup-appear 0.2s ease-out;">
                  <h5 style="margin: 0 0 0.5rem 0; color: #051B30; font-size: 14px;">Popup Título</h5>
                  <p style="margin: 0; font-size: 12px; color: #465059; line-height: 1.4;">Conteúdo do popup com animação de entrada e seta apontando para o elemento.</p>
                  <div style="margin-top: 0.8rem; display: flex; gap: 0.5rem;">
                    <button class="btn btn-primary btn-sm">Ação</button>
                    <button class="btn btn-outline btn-sm" @click="showPopup = false">Fechar</button>
                  </div>
                </div>

              </div>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 2rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">Popup • click-outside • animação</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Posicionamento absoluto • seta apontando • shadow • animação de entrada</div>
              <div style="color: #999; font-size: 11px;">src/components/shares/Popup.vue</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 14: SISTEMA DE ANIMAÇÕES -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Animações</h2>
        
        <!-- Loading Spinner -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Loading Spinner</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; align-items: center; gap: 2rem;">
              <div style="position: relative; width: 80px; height: 80px;">
                <Loading :load="showLoading" message="Carregando..." />
              </div>
              <div style="color: #465059; font-size: 12px;">
                <div style="font-weight: bold; margin-bottom: 0.3rem;">Componente Loading</div>
                <div>Animação lds-ripple • cubic-bezier • expansão circular</div>
                <button class="btn btn-outline btn-sm" style="margin-top: 0.5rem;" @click="toggleLoading">
                  {{ showLoading ? 'Parar' : 'Mostrar' }} Loading
                </button>
              </div>
            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">&lt;Loading :load="true" message="..."&gt;</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Animação @keyframes lds-ripple • 1s cubic-bezier • infinita</div>
              <div style="color: #999; font-size: 11px;">src/components/shares/Loading.vue</div>
            </div>
          </div>
        </div>

        <!-- Skeleton Loading -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Skeleton Loading</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              
              <div>
                <div class="skeleton" style="background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%); background-size: 1300px; animation: skeleton-gradient 1.7s ease infinite; border-radius: 3px; height: 30px; width: 100%;"></div>
                <div style="font-size: 11px; color: #465059; margin-top: 0.3rem;">Skeleton padrão - 1.7s</div>
              </div>

              <div>
                <div class="skeleton" style="background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%); background-size: 1300px; animation: skeleton-gradient 1.8s ease infinite; border-radius: 3px; height: 30px; width: 80%;"></div>
                <div style="font-size: 11px; color: #465059; margin-top: 0.3rem;">Skeleton lento - 1.8s</div>
              </div>

              <div>
                <div class="skeleton" style="background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%); background-size: 1300px; animation: skeleton-gradient 1.5s ease infinite; border-radius: 3px; height: 30px; width: 60%;"></div>
                <div style="font-size: 11px; color: #465059; margin-top: 0.3rem;">Skeleton rápido - 1.5s</div>
              </div>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">&lt;Skeleton :animation-duration="1.8s"&gt;</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Gradiente animado • background-position deslizante • duração configurável</div>
              <div style="color: #999; font-size: 11px;">src/components/utils/Skeleton.vue</div>
            </div>
          </div>
        </div>

        <!-- Transições de Navegação -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Transições de Interface</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; flex-direction: column; gap: 1.5rem;">
              
              <!-- Nav Hover Transition -->
              <div>
                <div class="nav-item" style="cursor: pointer; transition: 0.2s;">
                  <li style="list-style: none;">
                    <i style="display: block; margin-bottom: 0.5em; text-align: center;">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        <line x1="9" y1="9" x2="15" y2="9"/>
                        <line x1="9" y1="15" x2="15" y2="15"/>
                      </svg>
                    </i>Hover para ver transição
                  </li>
                </div>
                <div style="font-size: 11px; color: #465059; margin-top: 0.3rem;">Transição 0.2s nos items de navegação</div>
              </div>

              <!-- Rotate Animation -->
              <div style="display: flex; align-items: center; gap: 1rem;">
                <div style="transform: rotate(0deg); transition: transform 0.2s; cursor: pointer; padding: 0.5rem; border: 1px solid #E1E3EB; border-radius: 3px;" 
                     @mouseenter="rotateArrow"
                     @mouseleave="resetArrow"
                     ref="rotateElement">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </div>
                <div style="font-size: 11px; color: #465059;">Passe o mouse na seta - transition: transform 0.2s</div>
              </div>

              <!-- Text Blink Animation -->
              <div>
                <span :class="{ 'blink-animation': showBlink }" style="color: #E93F66;">● Status {{ showBlink ? 'piscando' : 'parado' }}</span>
                <div style="display: flex; align-items: center; gap: 1rem; margin-top: 0.3rem;">
                  <div style="font-size: 11px; color: #465059;">Animação text-blink - opacity 1 ↔ 0.2 ↔ 1</div>
                  <button class="btn btn-outline btn-sm" @click="toggleBlink">
                    {{ showBlink ? 'Parar' : 'Iniciar' }}
                  </button>
                </div>
              </div>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">transition: 0.2s • transform • opacity</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Transições suaves em hover • rotação de elementos • piscar de status</div>
              <div style="color: #999; font-size: 11px;">_nav.scss • _main.scss • ModalEvents.vue</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 15: SISTEMA DE TOOLTIPS -->
      <div style="margin-bottom: 2.5rem;">
        <h2 style="margin-bottom: 2rem; color: #051B30;">Sistema de Tooltips</h2>
        
        <!-- Tooltips com v-tooltip -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tooltips Vue Directive</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; flex-wrap: wrap; gap: 1.5rem; align-items: center;">
              
              <!-- Tooltip Right -->
              <button class="btn btn-outline" v-tooltip.right="'Tooltip à direita'">
                <i class="fas fa-copy"></i> Copiar
              </button>

              <!-- Tooltip Bottom -->
              <button class="btn btn-primary" v-tooltip.bottom="'Informação adicional'">
                <i class="fas fa-info-circle"></i> Info
              </button>

              <!-- Tooltip Top -->
              <div class="tag tag-blue" v-tooltip.top="'Status do item'" style="width: 20px; height: 20px; cursor: pointer;"></div>

              <!-- Tooltip Left -->
              <label style="cursor: help;" v-tooltip.left="'Campo obrigatório para validação'">
                Nome <i class="fas fa-question-circle" style="color: #465059;"></i>
              </label>

              <!-- Ícone com tooltip -->
              <i class="fas fa-barcode fd-icon" style="cursor: pointer; color: #2D98DA;" v-tooltip.bottom="'Copiar código de barras'"></i>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">v-tooltip.{position}</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">Diretiva Vue • posições: top, bottom, left, right • fundo escuro • texto branco</div>
              <div style="color: #999; font-size: 11px;">vue-directive-tooltip • src/main.js</div>
            </div>
          </div>
        </div>

        <!-- Tooltip Especializado para Modais -->
        <div style="margin-bottom: 2.5rem;">
          <h3 style="margin-bottom: 1rem; color: #051B30; font-size: 16px;">Tooltips em Modais</h3>
          <div style="background: white; border-radius: 6px; padding: 1.5rem; box-shadow: 0 1px 4px rgba(0,0,0,0.1);">
            
            <div style="display: flex; align-items: center; gap: 2rem;">
              
              <button class="btn btn-sp tooltip-in-modal" title="Tooltip com z-index alto">
                Modal Tooltip
                <i class="fas fa-external-link-alt" style="margin-left: 0.5rem;"></i>
              </button>

              <div style="color: #465059; font-size: 12px;">
                <div style="font-weight: bold; margin-bottom: 0.3rem;">Para Modais</div>
                <div>z-index 1100 para sobrepor modais</div>
              </div>

            </div>

            <div style="border-top: 1px solid #E1E3EB; padding-top: 1rem; margin-top: 1.5rem;">
              <div style="font-weight: bold; color: #051B30; margin-bottom: 0.3rem;">.tooltip-in-modal</div>
              <div style="color: #465059; font-size: 12px; margin-bottom: 0.2rem;">z-index: 1100 !important • para funcionar sobre modais Bootstrap</div>
              <div style="color: #999; font-size: 11px;">_tooltip.scss:1-3</div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import Select2 from '@/components/shares/Select2'
import Loading from '@/components/shares/Loading'
import BarcodeIcon from '@/components/icons/BarcodeIcon'

export default {
  components: {
    Select2,
    Loading,
    BarcodeIcon
  },
  data() {
    return {
      select2Values: ['ativo', 'pendente'],
      select2Options: [
        { label: 'Status Ativo', value: 'ativo' },
        { label: 'Status Pendente', value: 'pendente' },
        { label: 'Status Inativo', value: 'inativo' },
        { label: 'Status Bloqueado', value: 'bloqueado' },
        { label: 'Status Em Análise', value: 'analise' },
        { label: 'Status Aprovado', value: 'aprovado' }
      ],
      showModal: false,
      showLargeModal: false,
      showSmallModal: false,
      showPopup: false,
      showLoading: true,
      showBlink: true
    }
  },
  methods: {
    checkModalClick(event) {
      if (event.target === event.currentTarget) {
        this.showModal = false
      }
    },
    checkLargeModalClick(event) {
      if (event.target === event.currentTarget) {
        this.showLargeModal = false
      }
    },
    checkSmallModalClick(event) {
      if (event.target === event.currentTarget) {
        this.showSmallModal = false
      }
    },
    toggleLoading() {
      this.showLoading = !this.showLoading
    },
    rotateArrow() {
      this.$refs.rotateElement.style.transform = 'rotate(90deg)'
    },
    resetArrow() {
      this.$refs.rotateElement.style.transform = 'rotate(0deg)'
    },
    toggleBlink() {
      this.showBlink = !this.showBlink
    }
  },
  name: 'StyleGuide'
}
</script>

<style scoped>
.card {
  border-radius: 5px;
}

small.p {
  display: block;
  margin-top: 0.5rem;
  opacity: 0.8;
}

@keyframes popup-appear {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes skeleton-gradient {
  0% {
    background-position: -650px 0;
  }
  100% {
    background-position: 650px 0;
  }
}

@keyframes text-blink {
  0% { opacity: 1; }
  50% { opacity: 0.2; }
  100% { opacity: 1; }
}

.blink-animation {
  animation: text-blink 1.25s linear infinite;
}
</style>